import { ReactElement, SVGProps } from 'react';

function SVGWrong(props?: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155 155" {...props}>
      <path fill="#ff828c" d="M137 155H18a18 18 0 01-18-18V18A18 18 0 0118 0h119a18 18 0 0118 18v119a18 18 0 01-18 18zM57.6 50.1a7.5 7.5 0 00-5.3 12.8l14.85 14.86L52.3 92.6a7.5 7.5 0 1010.61 10.6l14.85-14.84 14.85 14.85a7.5 7.5 0 1010.6-10.61L88.37 77.76 103.2 62.9a7.5 7.5 0 00-10.6-10.61L77.76 67.15 62.9 52.3a7.45 7.45 0 00-5.3-2.2z"/>
    </svg>
  );
}

export default SVGWrong;
